import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { HealthDashboardComponent } from './health-dashboard/health-dashboard.component';
import { PDPMDashboardComponent } from './pdpm-dashboard/pdpm-dashboard.component';


const routes: Routes = [
  {
    path: '',
    component: DashboardComponent // Loads on /dashboard
  },
  {
    path: 'health',
    component: HealthDashboardComponent // Loads on /dashboard/health
  },
  {
    path: 'pdpm',
    component: PDPMDashboardComponent // Loads on /dashboard/health
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class fileManagerRoutingModule { }
